import {CoinsSections_Levels_Slider_Level} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import {useSlider} from '@aboutyou/ui-components';
import {useEffect, useRef} from 'react';

export const useCoinsLevelSlider = (
  levels: CoinsSections_Levels_Slider_Level[],
) => {
  const scrollWrapperRef = useRef<HTMLElement>(null);
  const {scrollToSlide} = useSlider(scrollWrapperRef);

  // auto scroll to the current level
  useEffect(() => {
    const currentLevelIndex = levels.findIndex(level => {
      switch (level.type?.$case) {
        case 'claimed':
          return level.type.claimed.isCurrent;
        case 'pending':
          return level.type.pending.isCurrent;
        case 'notReached':
          return level.type.notReached.isCurrent;
        default:
          return -1;
      }
    });

    if (currentLevelIndex !== -1) {
      scrollToSlide(currentLevelIndex, {centered: true});
    }
  }, [levels, scrollToSlide]);

  return {scrollWrapperRef};
};
